import { render, staticRenderFns } from "./ChartPCR.vue?vue&type=template&id=34e4fe24&scoped=true&"
import script from "./ChartPCR.vue?vue&type=script&lang=js&"
export * from "./ChartPCR.vue?vue&type=script&lang=js&"
import style0 from "./ChartPCR.vue?vue&type=style&index=0&id=34e4fe24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4fe24",
  null
  
)

export default component.exports